import { render } from "./OrderTypeChart.vue?vue&type=template&id=27657a56"
import script from "./OrderTypeChart.vue?vue&type=script&lang=js"
export * from "./OrderTypeChart.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__